(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["complementary-products"] && !Shopify.designMode) return;
  try {
    window.theme = window.theme || {};

const sectionsToRender = [
  {
    id: "Cart",
    section: "main-cart",
    selector: ".thb-cart-form",
  },
  {
    id: "Cart-Drawer",
    section: "cart-drawer",
    selector: ".cart-drawer",
  },
  {
    id: "cart-drawer-toggle",
    section: "cart-bubble",
    selector: ".thb-item-count",
  },
];

document.addEventListener('submit', function(e) {
  if (e.target.matches('.complementary-product')) {
    e.preventDefault();

    const submitButton = e.target.querySelector('button[type="submit"]');
    submitButton.classList.add("loading");

    const formData = new FormData(e.target);
    formData.append(
      "sections",
      sectionsToRender.map((section) => section.section),
    );
    formData.append("sections_url", window.location.pathname);

    fetch(`${theme.routes.cart_add_url}`, {
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        Accept: "application/javascript",
      },
      body: formData
    })
    .then((response) => response.json())
    .then((data) => {
      if (data.status) return;

      sectionsToRender.forEach((section) => {
        if (!document.getElementById(section.id)) {
          return;
        }

        const elementToReplace = document
          .getElementById(section.id)
          .querySelector(section.selector) 
          || document.getElementById(section.id);

        elementToReplace.innerHTML = new DOMParser()
          .parseFromString(data.sections[section.section], "text/html")
          .querySelector(section.selector).innerHTML;
      });

      dispatchCustomEvent("cart:item-added", {
        product: data
      });

      document.dispatchEvent(new CustomEvent("cartChanged"));

      if (typeof CartDrawer !== "undefined") {
        new CartDrawer().openCart();
      }

      submitButton.classList.remove("loading");
    })
    .catch((error) => {
      console.error(error);
      submitButton.classList.remove("loading");
    });
  }
});
  } catch(e) { console.error(e); }
})();

})();
